import axios from 'axios';
import { APIKey, APIKeyCreateRequest } from './apiKey';

const API_BASE_URL = '/api/keys';

export const apiKeyService = {
  // Get all API keys for the current user
  async getAllApiKeys(): Promise<APIKey[]> {
    const response = await axios.get<APIKey[]>(API_BASE_URL);
    return response.data;
  },

  // Get a specific API key by ID
  async getApiKey(id: string): Promise<APIKey> {
    const response = await axios.get<APIKey>(`${API_BASE_URL}/${id}`);
    return response.data;
  },

  // Create a new API key
  async createApiKey(apiKeyData: APIKeyCreateRequest): Promise<APIKey> {
    console.log('Creating API key with data:', apiKeyData);
    const response = await axios.post<APIKey>(API_BASE_URL, {
      name: apiKeyData.name,
      projectId: apiKeyData.projectId || null
    });
    return response.data;
  },

  // Update an existing API key
  async updateApiKey(id: string, apiKeyData: APIKeyCreateRequest): Promise<APIKey> {
    console.log('Updating API key with data:', apiKeyData);
    const response = await axios.put<APIKey>(`${API_BASE_URL}/${id}`, {
      name: apiKeyData.name,
      projectId: apiKeyData.projectId || null
    });
    return response.data;
  },

  // Delete an API key
  async deleteApiKey(id: string): Promise<void> {
    await axios.delete(`${API_BASE_URL}/${id}`);
  },

  // Toggle API key active status
  async toggleApiKeyStatus(id: string): Promise<APIKey> {
    const response = await axios.patch<APIKey>(`${API_BASE_URL}/${id}/toggle`);
    return response.data;
  }
};
